export default "__VITE_ASSET__CG$T_jqo__"